$(function () {
  var today = new Date(),
      month = today.getMonth() + 1,
      day = today.getDate(),
      dayOfWeek = today.getDay(),
      dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek];
  $('.js-date').find('.js-month').text(month);
  $('.js-date').find('.js-date').text(day);
  $('.js-date').find('.js-type').text(dayOfWeekStr);
});